<template>
  <div class="attendEveryday">
    <Card class="card">
      <el-row :gutter="20">
        <el-col :span="5">
          考勤时间：
          <Date-picker
            :value="period"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-start"
            placeholder="选择日期"
            style="width: 200px"
            @on-change="getPeriod"
          ></Date-picker>
        </el-col>
        <el-col :span="4">
          <SelectPeople
            ref="selectPeople"
            @byEmployee='getEmployee($event)' @byDepartment='getDepartment($event)'
          ></SelectPeople>
        </el-col>
        <el-col :span="15">
          <div align="right">
            <Button icon="md-add" type="primary" @click="fieldsModel = true">字段设置</Button>
          </div>
        </el-col>
      </el-row>
      <div>
        <tableList-com
          ref="tableList"
          :button="button"
          :tableHead="selectedHeaders"
          :params="params"
          :api="api"
          @getDetail="getDetail($event)"
        ></tableList-com>
      </div>
    </Card>
    <Modal v-model="fieldsModel" width="700" @on-cancel="cancelTableHeaderSetting">
      <Form :model="fieldsData" label-position="left" :label-width="120" class="fieldsBox">
        <FormItem label="选择需要展示的字段">
          <CheckboxGroup v-model="fieldsData.type" style="width:100%;">
            <Checkbox
              v-for="item in couldSelectedColumns"
              :label="item.prop"
              :key="item.prop"
              style="margin-right: 40px;"
            >{{item.label}}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelTableHeaderSetting">取消</Button>
        <Button @click="saveTableHeaderSetting" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
const typeCode = "punchCard";
const initTableHeaderData = [
  // "employeeName",
  "attendanceDate",
  "attendanceTime",
  "pushCardTime",
  "status",
  "address",
  "cardTool",
];
import SelectPeople from "@/components/business/selectEmployee/selectEmployee";

import page from "@/components/page/pageSecond.vue";
import Apis from "@/api"
import tableList from "@/view/management/personnel/common/editableTable.vue";
export default {
  created() {
    this.initTableHeader();
  },
  components: {
    "page-com": page,
    "tableList-com": tableList,
    SelectPeople
  },
  methods: {
    initTableHeader() {
      this.$api.getHeadersList(typeCode).then(res => {
        if (!res) {
          this.setAllColumns();
          return;
        }
        this.fieldsData.type = res.columnCodes;
        this.fieldsDataSaved = res.columnCodes;
      });
    },
    setAllColumns: function () {
      this.fieldsData.type = this.workCountTypeAll.map((e) => e.prop);
      this.fieldsDataSaved = this.fieldsData.type;
    },
    saveTableHeaderSetting() {
      let requestData = {
        columnCodes: this.fieldsData.type,
        typeCode: typeCode
      };

      this.$api.saveHeaders(requestData).then(() => {
        this.$Message.success("保存成功！");
        this.fieldsDataSaved = this.fieldsData.type;
        this.fieldsModel = false;
      });
    },

    cancelTableHeaderSetting() {
      this.fieldsModel = false;
      this.fieldsData.type = this.fieldsDataSaved;
    },

    getList() {
      this.orgParams();
      this.refresh();
    },
    getEmployee(val){
      this.employeeIds = val;
      this.getList();
    },
    getDepartment(val){
      this.departmentIds = val;
    },
    /**
     * 整合所有的查询过滤条件
     */
    orgParams() {
      let params = {
        employeeIds: this.employeeIds,
        orgIds: this.departmentIds,
        period: this.period
      };
      this.params.conditions = this.$js.parseSqlParams(params);
    },
    refresh() {
      if (this.$refs.tableList) {
        this.$refs.tableList.refresh();
      }
    },
    getPeriod(date) {
      this.period = date;
      this.orgParams();
      this.refresh();
    },
  },
  computed: {
    button: function() {
      return {
        editButton: {
          enable: false //是否加载编辑按钮
        },
        addButton: {
          enable: false //是否加载新增按钮
        },
        enableButton: {
          enable: false //是否加载禁用按钮
        }
      };
    },
    api: function() {
      return {
        list: Apis.getRecordsHistoryList,
        funcs: [], //列表操作列附加功能按钮
        operation: {
          enable: false
        }
      };
    },

    couldSelectedColumns() {
      return this.workCountTypeAll.filter(e => initTableHeaderData.indexOf(e.prop) >= 0);
    },

    selectedHeaders() {
      let filterTableHeader = this.workCountTypeAll.filter(
              val => this.fieldsDataSaved.indexOf(val.prop) >= 0
      );
      return filterTableHeader;
    }
  },
  data() {
    return {
      employeeIds: [],
      departmentIds: [],
      period: [""],
      parentFunc: "getOrgUser",
      params: {
        conditions: [] //列表查询过滤条件
      },
      //面包屑数据
      breadData: {
        firstBread: "人事管理",
        secondBread: "考勤管理",
        thirdBread: "打卡记录"
      },
      //字段弹出框状态
      fieldsModel: false,
      //字段设置
      fieldsData: {
        type: initTableHeaderData.concat(),
        unit: "",
        leave: ""
      },
      fieldsDataSaved: initTableHeaderData.concat(),
      //表头数据
      workCountTypeAll: [
        {
          label: "姓名",
          prop: "employeeName"
        },
        {
          label: "日期",
          prop: "attendanceDate"
        },
        {
          label: "部门",
          prop: "departmentName"
        },
        {
          label: "工号",
          prop: "employeeNumber"
        },
        {
          label: "职位",
          prop: "position"
        },

        {
          label: "考勤时间",
          prop: "attendanceTime"
        },
        {
          label: "打卡时间",
          prop: "pushCardTime"
        },
        {
          label: "打卡结果",
          prop: "status",
          align: "center",
          minWidth: 100
        },
        {
          label: "打卡地址",
          prop: "address"
        },
        {
          label: "打卡备注",
          prop: "remark"
        },
        {
          label: "项目",
          prop: "projectName"
        },
        {
          label: "打卡设备",
          prop: "cardTool"
        },
        {
          label: "修改记录",
          prop: "edit",
          align: "center",
          hasChild: true,
          children: [
            {
              label: "修改人",
              prop: "operatorName"
            },
            {
              label: "修改时间",
              prop: "modifyTime"
            },
            {
              label: "修改原因",
              prop: "modifyReason"
            }
          ]
        }
      ],
      workCountData: []
    };
  }
};
</script>


<style scoped>
  @import url("../../common/layout.css");

  .search {
    float: right;
    width: 200px;
  }

  .btn {
    height: 50px;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .fieldsBox {
    padding: 20px 0 0 40px;
  }

  .row-bg {
    padding: 1px 0;
    background-color: #f9fafc;
  }
</style>
